export const AUTH_TOKEN = '@smart-revision-auth-token'
export const USER_TOKEN = '@smart-revision-user-token'
